// extracted by mini-css-extract-plugin
export default {"contactDetailsTitle":"_1I-MK _2AZKg","contactDetailsBody":"_3azz9"};